import { render, staticRenderFns } from "./TaxesQuestions.vue?vue&type=template&id=c9c22198"
import script from "./TaxesQuestions.vue?vue&type=script&lang=js"
export * from "./TaxesQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports